import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ROUTES } from '../../config/constants';

const TenantRoute = ({ children }) => {
    const { isAuthenticated, hasTenantSelected, loading } = useAuth();

    if (loading) {
        return <div>Loading...</div>; // Oder eine Loading-Komponente
    }

    if (!isAuthenticated) {
        return <Navigate to={ROUTES.LOGIN} replace />;
    }

    if (!hasTenantSelected) {
        return <Navigate to={ROUTES.TENANT_SELECTION} replace />;
    }

    return children;
};

export default TenantRoute;